/**
 * External dependencies
 */

export default class Location {
  constructor(id, cscom) {
    if (!(this instanceof Location)) {
      return new Location(id, cscom);
    }
    this.cscom = cscom;
    this.id = id;

    if (this.id) {
      this.path = `/api/rest/talink/locations/${this.id}`;
    } else {
      this.path = `/api/rest/talink/locations`;
    }
  }

  listAll() {
    return this.cscom.req.get(this.path, null).then((result) => {
      return result;
    });
  }
}
